import { AppConfig } from "@/config/app.config";
import {
    acceptLanguage,
    commonErrorHandler,
    DecoratorRegistry,
    performanceLogging,
    provideApiVersion,
    provideRequestTimestamp,
    provideRetryAttempt,
    provideSessionOpaqueToken,
    provideTracingAndIdempotency,
    registerConnector,
    routingWithConditions,
    serverTime,
} from "mfe-lib-bfo-shared/query";
import { sessionManager, tokenManager } from "mfe-lib-bfo-shared/session";
import { useDefaultApiError } from "./error/useDefaultApiError";
import { useDefaultNetworkError } from "./error/useDefaultNetworkError";

export function useRegisterPostLoginDecorators(i18n: any) {
    const decoratorApiError = useDefaultApiError();
    const decoratorNetworkError = useDefaultNetworkError();

    const commonDecorators = [
        performanceLogging(),
        serverTime(),
        acceptLanguage(i18n),
        provideRequestTimestamp(),
        provideTracingAndIdempotency(),
        provideRetryAttempt(),
        provideApiVersion(),
    ];

    const sessionTokenProvider = {
        getToken: tokenManager.getToken.bind(tokenManager),
        getRefreshToken: tokenManager.getRefreshToken.bind(tokenManager),
        getValidToken: tokenManager.getValidToken.bind(tokenManager),
        refreshTokenWithLocks: tokenManager.refreshTokenWithLocks.bind(tokenManager),
        waitForRefresh: tokenManager.waitForRefresh.bind(tokenManager),
        recordActivity: sessionManager.recordActivity.bind(sessionManager),
        logout: sessionManager.logout.bind(sessionManager),
    };

    const postLoginWithErrors = new DecoratorRegistry();

    postLoginWithErrors.registerMany([
        ...commonDecorators,
        commonErrorHandler(decoratorApiError, decoratorNetworkError),
        routingWithConditions({
            redirectUrl: "/login",
            condition: ({ response }) => response.status === 405,
        }),
        provideSessionOpaqueToken({
            tokenName: "user",
            opaqueTokenHeaderName: "user",
            tokenProvider: sessionTokenProvider,
        }),
    ]);

    const postLogin = new DecoratorRegistry();

    postLogin.registerMany([
        ...commonDecorators,
        routingWithConditions({
            redirectUrl: "/login",
            condition: ({ response }) => response.status === 405,
        }),
        provideSessionOpaqueToken({
            tokenName: "user",
            opaqueTokenHeaderName: "user",
            tokenProvider: sessionTokenProvider,
        }),
    ]);

    const apiBaseUrl = AppConfig.getBaseUrl();

    registerConnector({
        name: "postLogin",
        baseUrl: apiBaseUrl,
        registry: postLogin,
    });

    registerConnector({
        name: "postLogin_admin",
        baseUrl: apiBaseUrl,
        registry: postLogin,
    });

    registerConnector({
        name: "postLogin_withErrors",
        baseUrl: apiBaseUrl,
        registry: postLoginWithErrors,
    });
}
